
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CommonBlockLine from '@/components/common/CommonBlockLine.vue';
import { getOldInterface } from '@/apis/index';
import {
  formatName,
  formatRead,
  formatDate,
  jumpReport,
  changeRatingStyle,
  jumpTimeShare,
  pushBy2804,
  formatTime,
  takePat,
  formatChg,
  formatManyChg,
} from '@/utils/tools';
import CommonReportChart from '@/components/common/CommonReportChart.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import { STAT, URLVER, FUTURES_REPORT_TYPE } from '@/config/config';

@Component({
  components: {
    CommonBlockLine,
    CommonReportChart,
    CommonRankNumber,
  },
})
export default class AnalystReport extends Vue {
  temp = 0;
  //控制关注/未关注的参数
  isSub = 0;
  @Prop() private item!: any;
  @Prop() private chart!: boolean;
  @Prop() private index!: number;
  @Prop() private needSub!: boolean;
  @Prop() private needFollow!: boolean;
  @Prop() private reportList!: Array<object>;
  @Prop() private deepReport!: boolean;
  @Prop() private goalNeedDivide!: boolean;
  @Prop() private searchRating!: boolean;
  @Prop() private activeIndex!: number;
  @Prop() private priceData!: any;
  formatName = formatName;
  formatRead = formatRead;
  formatDate = formatDate;
  formatChg = formatChg;
  formatManyChg = formatManyChg;
  inPage = '';
  $toast: any;
  @Watch('$route', { deep: true, immediate: true })
  // eslint-disable-next-line consistent-return
  onRouteChange(newVal: any) {
    if (newVal.name === 'home') {
      if (this.activeIndex === 0) {
        this.inPage = STAT.zxg;
      } else {
        this.inPage = STAT.follow;
      }
    } else if (newVal.name === 'mainPage') {
      if (window.getParam('swCode') !== '') {
        this.inPage = STAT.industry;
      }
      if (window.getParam('authorId') !== '') {
        this.inPage = STAT.author;
      }
      if (window.getParam('orgId') !== '') {
        this.inPage = STAT.org;
      }
    } else if (newVal.name === 'stockPage') {
      this.inPage = STAT.stock;
    } else if (newVal.name === 'iframe') {
      this.inPage = STAT.kline;
    } else {
      return false;
    }
  }
  get isFollow() {
    const { authorId, orgId, organizationId } = this.item as any;
    if (!authorId) {
      return this.$followOrgList[orgId || organizationId];
    } else {
      return authorId ? this.$followAuthorList[authorId] : this.$followOrgList[orgId || organizationId];
    }
  }
  get isSelfMedia() {
    const { authorId, orgId, organizationId } = this.item as any;
    // 区分普通渠道自媒体专栏
    return !authorId && !orgId && !organizationId;
  }
  get isFuturesReport() {
    const { catId } = this.item as any;
    return catId === FUTURES_REPORT_TYPE;
  }
  get canBeFollowed() {
    return !this.isSelfMedia && !this.isFuturesReport;
  }
  followInstead(item: any, status: any) {
    getOldInterface({
      act: 'follow',
      con: 'user',
      type: item.authorId ? 3 : 2,
      status,
      followId: item.authorId || item.orgId || item.organizationId,
    })
      .then(res => {
        if (res.statusCode === 0) {
          this.followSet(item, status);
          if (status === 1) {
            window.hxmPageStat(`${STAT.zxg}.guanzhu`, URLVER);
          } else {
            window.hxmPageStat(`${STAT.zxg}.jianguanzhu`, URLVER);
          }
        }
        if (res.statusCode === 300) {
          this.$toast('用户未登录');
        }
      })
      .catch(() => {
        this.$toast('服务器开小差了');
      });
  }
  followSet(item: any, status: number) {
    this.isSub = 0;
    if (status > 0) {
      this.isSub = 2;
    } else {
      this.isSub = 1;
    }
    if (item.authorId) {
      this.$set(this.$followAuthorList, item.authorId, this.isSub);
    } else {
      this.$set(this.$followOrgList, item.orgId || item.organizationId, this.isSub);
    }
  }
  followAuthor(item: any, status: any) {
    if (!window.getAccount()) {
      window.location.href = 'http://eqhexin/changeUser';
    } else {
      this.followInstead(item, status);
    }
  }
  get stockInfo() {
    const {
      name,
      market,
      stockName,
      stockCode,
      orgName,
      orgId,
      author,
      authorId,
      code,
      organization,
      organizationId,
      pid,
    } = this.item as any;
    return {
      stockName: name || stockName,
      stockCode: code || stockCode,
      orgName,
      orgId,
      author,
      code,
      authorId,
      organization,
      organizationId,
      market,
      pid,
    };
  }
  jumpTitleReport() {
    this.sendStatAll('title');
    if (this.$route.name === 'iframe') {
      window.hxmPageStat(`${STAT.kline}.zxyb.title.click`, URLVER);
    }
    this.item.pid && jumpReport(this.item.pid, this.isSelfMedia);
  }
  changeListStyle(j: any) {
    if (j !== 0) {
      return {
        marginLeft: '0.16rem',
      };
    } else {
      return false;
    }
  }
  sendStatAll(action: any) {
    if (this.$route.name === 'mainPage') {
      if (window.getParam('swCode') !== '') {
        window.hxmPageStat(`${STAT.industry}.${action}`, URLVER);
      } else {
        window.hxmPageStat(`${STAT.author}.${action}`, URLVER);
      }
    } else if (this.$route.name === 'stockPage') {
      window.hxmPageStat(`${STAT.stock}.${action}`, URLVER);
    } else {
      if (this.activeIndex === 0) {
        window.hxmPageStat(`${STAT.zxg}.${action}`, URLVER);
      }
      if (this.activeIndex === 1) {
        window.hxmPageStat(`${STAT.follow}.${action}`, URLVER);
      }
    }
  }
  //跳转分时
  jumpToFenshi(item: any) {
    this.sendStatAll('ggfs');
    const params = {
      market: item.market || item.marketId,
      stockCode: item.stockCode || item.code,
    };
    jumpTimeShare(params);
  }
  //多个股票跳转分时
  jumpFenshi(item: any, j: number) {
    this.sendStatAll('ggfs');
    if (item.stockCode) {
      const params = {
        market: null,
        stockCode: item.stockCode.split('!')[j],
      };
      jumpTimeShare(params);
    } else {
      const params = {
        market: null,
        stockCode: item.code.split('!')[j],
      };
      jumpTimeShare(params);
    }
  }
  //跳转研报详情
  jumpReport() {
    this.item.pid && jumpReport(this.item.pid, this.isSelfMedia);
  }
  //拍一拍
  takePat(index: number) {
    takePat(this, index);
  }
  // eslint-disable-next-line consistent-return
  clickDate(index: number) {
    if (window.location.href.indexOf('mainPage') !== -1 && window.getParam('swCode') === '') {
      this.takePat(index);
    } else {
      return false;
    }
  }
  //主页点击头像拍一拍
  clickAvatar(index: number, item: any) {
    if (this.activeIndex === 1) {
      window.hxmPageStat(`${STAT.follow}.fxszy`, URLVER);
    }
    if (this.activeIndex === 0) {
      window.hxmPageStat(`${STAT.zxg}.fxszy`, URLVER);
    }
    if (this.$route.name === 'mainPage' && window.getParam('swCode') === '') {
      this.takePat(index);
    } else if (this.$route.name === 'stockPage') {
      this.jumpAuthor(item);
      window.hxmPageStat(`${STAT.stock}.fxszy`, URLVER);
    } else {
      this.jumpAuthor(item);
    }
  }
  jumpAuthor(item: any) {
    if (window.getParam('swCode') !== '') {
      window.hxmPageStat(`${STAT.industry}.fxszy`, URLVER);
    }
    if (this.$route.name === 'iframe') {
      window.hxmPageStat(`${STAT.kline}.zxyb.author.authorpage`, URLVER);
    }
    if (!this.canBeFollowed) {
      return;
    }
    if (item.authorId) {
      const param = {
        authorId: item.authorId,
        name: item.author,
        org: item.orgName || item.organization,
      };
      pushBy2804('/mainPage', param);
    }
  }
  newJumpOrg(index: number, item: any) {
    if (this.$route.name === 'mainPage') {
      this.takePat(index);
    } else {
      window.hxmPageStat(`${STAT.follow}.jgzy`, URLVER);
    }
    this.ifJumpOrg(item);
  }
  ifJumpOrg(item: any) {
    if (!this.canBeFollowed) {
      return;
    }
    if (item.orgId || item.organizationId) {
      const param = {
        orgId: item.orgId || item.organizationId,
        name: item.orgName || item.organization,
      };
      pushBy2804('/mainPage', param);
    }
  }
  jumpToOrg(item: any) {
    if (this.$route.name === 'mainPage') {
      if (window.getParam('swCode') === '') {
        window.hxmPageStat(`${STAT.author}.jgzy`, URLVER);
      } else {
        window.hxmPageStat(`${STAT.industry}.jgzy`, URLVER);
      }
    } else if (this.$route.name === 'stockPage') {
      window.hxmPageStat(`${STAT.stock}.jgzy`, URLVER);
    } else {
      if (this.activeIndex === 0) {
        window.hxmPageStat(`${STAT.zxg}.jgzy`, URLVER);
      }
      if (this.activeIndex === 1) {
        window.hxmPageStat(`${STAT.follow}.jgzy`, URLVER);
      }
      if (this.$route.name === 'iframe') {
        window.hxmPageStat(`${STAT.kline}.zxyb.author.insititutionpage`, URLVER);
      }
    }
    this.ifJumpOrg(item);
  }
  formatRating(rating: number) {
    switch (rating) {
      case 0:
        return '不评级';
      case 1:
        return '买入';
      case 2:
        return '增持';
      case 3:
        return '中性';
      case 4:
        return '减持';
      case 5:
        return '卖出';
      default:
        return false;
    }
  }
  changeDate(time: any) {
    const now = new Date();
    const publish = new Date(time.replace(new RegExp(/-/gm), '/'));
    const obj = {
      '-86400000': '昨日',
      '0': '今日',
    };
    return obj[publish.setHours(0, 0, 0, 0) - now.setHours(0, 0, 0, 0)] || formatTime(publish, 'yyyy-MM-dd');
  }
  formatTime(time: any) {
    if (this.$route.name === 'search') {
      const date = new Date(time * 1000);
      const getMonth = `0${date.getMonth() + 1}`;
      const getDate = `0${date.getDate()}`;
      const Y = `${date.getFullYear()}-`;
      const M = `${date.getMonth() + 1 < 10 ? getMonth : date.getMonth() + 1}-`;
      const D = `${date.getDate() < 10 ? getDate : date.getDate()} `;
      return this.changeDate(Y + M + D);
    } else {
      return this.changeDate(time);
    }
  }
  changeStyle(item: any) {
    return changeRatingStyle(this.deepReport, item);
  }
  changeSearchStyle(item: any) {
    switch (item.buyRating) {
      case '买入':
        return {
          color: '#FF2436',
        };
      case '增持':
        return {
          color: '#FF661A',
        };
      case '中性':
        return {
          color: '#FF9500',
        };
      case '减持':
        return {
          color: '#39BC6F',
        };
      case '卖出':
        return {
          color: '#07AB4B',
        };
      default:
        return false;
    }
  }
}
